"use strict";

exports.__esModule = true;
exports.default = void 0;

var _convertUnits = _interopRequireDefault(require("convert-units"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getUnit = function getUnit(unit, aliases) {
  var _aliases$find;

  return ((_aliases$find = aliases.find(function (el) {
    return el.aliases.includes(unit);
  })) == null ? void 0 : _aliases$find.unit) || unit;
};

var formatUnit = function formatUnit(value, unit, t, digits) {
  if (digits === void 0) {
    digits = 2;
  }

  return +(value == null ? void 0 : value.toFixed(digits)) + " " + t(unit);
};

var convertUnit = function convertUnit(value, originalUnit, displayUnit, aliases, t, digits) {
  if (!displayUnit) return formatUnit(value, originalUnit, t, digits);

  if (aliases != null && aliases.length) {
    originalUnit = getUnit(originalUnit, aliases);
    displayUnit = getUnit(displayUnit, aliases);
  }

  try {
    var convertedValue;

    if (displayUnit === 'bestFit') {
      var bestFit = (0, _convertUnits.default)(value).from(originalUnit).toBest();
      displayUnit = bestFit.unit;
      convertedValue = bestFit.val;
    } else {
      convertedValue = (0, _convertUnits.default)(value).from(originalUnit).to(displayUnit);
    }

    return formatUnit(convertedValue, displayUnit, t);
  } catch (error) {
    return formatUnit(value, originalUnit, t);
  }
};

var _default = convertUnit; // 'ns'| 'mu' | 'ms' | 's' | 'min' | 'h' | 'd' | 'week' | 'month' | 'year';
// 'B' | 'KB' | 'MB' | 'GB' | 'TB';
// bestFit => (the smallest unit with a value above 1)

exports.default = _default;